import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddAppointmentPricing = () => {
  const [type, setType] = useState();
  const [price, setPrice] = useState();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const handleAddAppointmentPricing = () => {
    navigate("/add-appointment-pricing");
  };
  const handleViewAllAppointmentPricing = () => {
    navigate("/all-appointment-pricing");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare the data payload
    const payload = {
      type,
      price,
    };

    // Send a POST request
    axios
      .post(`${API_BASE_URL}/admin/pricing/appointment`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        alert("Appointment pricing added successfully!");
        navigate("/all-appointment-pricing");
      })
      .catch((error) => {
        console.error("Error adding appointment pricing:", error);
        alert("Failed to add appointment pricing. Please try again.");
      });
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Appointment Pricing</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={handleAddAppointmentPricing}
            >
              + Add New Appointment Pricing
            </button>
            <button
              className="allSubjects"
              onClick={handleViewAllAppointmentPricing}
            >
              All Appointment Pricing
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Appointment Pricing Detail</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Type</label>
              </div>
              <select
                className="select-dropdown"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">-Select Type-</option>
                <option value="online">Online</option>
                <option value="offline">Offline</option>
              </select>
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Price</label>
              </div>
              <input
                type="text"
                placeholder="Enter Coupon Code"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/all-appointment-pricing")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddAppointmentPricing;
